/**
 * フッター用 FullCalendar（v6）。
 * 祝日: Nager.Date API ＋ customClosedSet（独自休業日）
 *
 * CSS は render() 直後に footer-fullcalendar.css を <link> で挿入する。
 * 日付・曜日の <a> は DOM で <span> に差し替えないこと。
 */
document.addEventListener('DOMContentLoaded', function () {
  var el = document.getElementById('footer-fullcalendar');
  if (!el || typeof FullCalendar === 'undefined') return;
  if (el.dataset.fcInit === '1') return;
  el.dataset.fcInit = '1';

  function injectOverridesCss() {
    if (document.getElementById('footer-fc-overrides-css')) return;

    var href = window.FOOTER_FULLCALENDAR_CSS
      ? String(window.FOOTER_FULLCALENDAR_CSS).trim()
      : '';

    if (!href) {
      var scripts = document.querySelectorAll('script[src]');
      for (var i = 0; i < scripts.length; i++) {
        var src = scripts[i].src;
        if (src.indexOf('footer-fullcalendar') !== -1 && /\.js(\?|$)/.test(src)) {
          href = src.replace(/\.js(\?.*)$/, '.css$1').replace(/\.js$/, '.css');
          break;
        }
      }
    }

    if (!href) {
      console.warn('[footer-fullcalendar] footer-fullcalendar.css の URL を特定できませんでした。');
      return;
    }

    var link = document.createElement('link');
    link.id = 'footer-fc-overrides-css';
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  var jpHolidaySet = new Set();
  var jpHolidayYearPromises = {};

  /**
   * 独自休業日（YYYY-MM-DD）
   * 年が決まったら該当ブロックに追記。不要になった年はブロックごと削除可。
   */
  var customClosedSet = new Set([
    // 2026年
    '2026-08-10', '2026-08-12', '2026-08-13', '2026-08-14', '2026-09-22',
    '2026-12-28', '2026-12-29', '2026-12-30', '2026-12-31',
    // 2027年
    '2027-01-04', '2027-01-05',
  ]);

  function dateKey(date) {
    return date.toLocaleDateString('en-CA', { timeZone: 'Asia/Tokyo' });
  }

  function ensureJpPublicHolidays(year) {
    if (jpHolidayYearPromises[year]) return jpHolidayYearPromises[year];
    jpHolidayYearPromises[year] = fetch(
      'https://date.nager.at/api/v3/publicholidays/' + year + '/JP'
    )
      .then(function (r) {
        if (!r.ok) throw new Error('nager');
        return r.json();
      })
      .then(function (list) {
        if (!Array.isArray(list)) return;
        list.forEach(function (h) {
          if (h && h.date) jpHolidaySet.add(h.date);
        });
      })
      .catch(function () {
        delete jpHolidayYearPromises[year];
      });
    return jpHolidayYearPromises[year];
  }

  function loadHolidaysForRange(start, end, onMaybeUpdated) {
    var promises = [];
    for (var y = start.getFullYear(); y <= end.getFullYear(); y++) {
      promises.push(ensureJpPublicHolidays(y));
    }
    var before = jpHolidaySet.size;
    Promise.all(promises).then(function () {
      if (onMaybeUpdated && jpHolidaySet.size > before) {
        onMaybeUpdated();
      }
    });
  }

  var calendar;
  var options = {
    initialView: 'dayGridMonth',
    locale: 'ja',
    timeZone: 'Asia/Tokyo',
    firstDay: 0,
    height: 'auto',
    headerToolbar: {
      left: 'prev',
      center: 'title',
      right: 'next',
    },
    navLinks: false,
    displayEventTime: false,
    dayHeaderFormat: { weekday: 'narrow' },
    dayCellContent: function (arg) {
      return { html: String(arg.date.getDate()) };
    },
    dayHeaderClassNames: function (arg) {
      if (arg.dow === 0) return ['fc-dow-sun'];
      if (arg.dow === 6) return ['fc-dow-sat'];
      return [];
    },
    dayCellClassNames: function (arg) {
      var key = dateKey(arg.date);
      var isHoliday = jpHolidaySet.has(key) || customClosedSet.has(key);
      var isSun = arg.dow === 0;
      var isSat = arg.dow === 6;
      var closed = isSun || isSat || isHoliday;
      var classes = [];

      if (arg.isOther && !closed) classes.push('fc-other');
      if (closed) {
        classes.push('fc-closed');
        if (arg.isOther) classes.push('fc-muted');
      }
      if (isSun) classes.push('fc-sun');
      else if (isSat) classes.push('fc-sat');
      else if (isHoliday) classes.push('fc-holiday');

      return classes;
    },
    datesSet: function (info) {
      loadHolidaysForRange(info.start, info.end, function () {
        if (calendar) calendar.render();
      });
    },
  };

  calendar = new FullCalendar.Calendar(el, options);
  calendar.render();
  injectOverridesCss();
});
